var _path, _path2, _path3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 9C0.5 13.6944 4.30558 17.5 9 17.5C13.6944 17.5 17.5 13.6944 17.5 9C17.5 4.30558 13.6944 0.5 9 0.5C4.30558 0.5 0.5 4.30558 0.5 9Z",
    stroke: "#CCCCCC",
    strokeOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79289 9L7.14645 6.73162C6.95118 6.56425 6.95118 6.29289 7.14645 6.12553C7.34171 5.95816 7.65829 5.95816 7.85355 6.12553L10.8536 8.69695C11.0488 8.86432 11.0488 9.13568 10.8536 9.30305L7.85355 11.8745C7.65829 12.0418 7.34171 12.0418 7.14645 11.8745C6.95118 11.7071 6.95118 11.4358 7.14645 11.2684L9.79289 9Z",
    fill: "#949494"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_357_4814",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 6,
    width: 4,
    height: 6
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79289 9L7.14645 6.73162C6.95118 6.56425 6.95118 6.29289 7.14645 6.12553C7.34171 5.95816 7.65829 5.95816 7.85355 6.12553L10.8536 8.69695C11.0488 8.86432 11.0488 9.13568 10.8536 9.30305L7.85355 11.8745C7.65829 12.0418 7.34171 12.0418 7.14645 11.8745C6.95118 11.7071 6.95118 11.4358 7.14645 11.2684L9.79289 9Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_357_4814)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMore);
export default __webpack_public_path__ + "static/media/ico-more.9bbefd449b8a9923f96a5702ee8ec6e2.svg";
export { ForwardRef as ReactComponent };